import { useCallback } from 'react';
import { parseParam, convertParam } from './converters';
import type { GetStorageParams } from './types';

export type GetUrlParamActionsParams = {
  name: string;
  search?: string;
  history?: { push: (path: string) => void };
};

export const useStorage = <T>({
  storageKey,
  storageType,
}: GetStorageParams<T>) => {
  const storage = storageType === 'session' ? sessionStorage : localStorage;
  const key = storageKey ? `sp-corporate-ui.${storageKey}` : undefined;

  const getParam = useCallback(() => {
    try {
      const param = key ? storage.getItem(key) : undefined;

      return parseParam<T>(param);
    } catch (ex) {
      return undefined;
    }
  }, [key, storage]);

  const setParam = useCallback(
    (param?: T) => {
      if (!key) return;

      const urlParam = convertParam(param);
      urlParam ? storage.setItem(key, urlParam) : storage.removeItem(key);
    },
    [key, storage]
  );

  return [getParam, setParam] as const;
};
